import { FETCH_PAYMENT_DETAILS } from '../actions/types';

export default function (state = [], action) {
	switch (action.type) {
		case FETCH_PAYMENT_DETAILS:
			return action.payload;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/paymentReducer.js